import { faExclamationCircle } from "@fortawesome/pro-regular-svg-icons";

import Icon from "common/components/Icon";
import { ADDRESS_REASON_CODE_MESSAGES, AddressReasonCode } from "common/constants/address";
import { IVerifyAddress } from "common/types/addresses";

import Button from "client/common/components/buttons/Button";
import { useCurrentDialog } from "client/common/hooks/stackables";

import styles from "../../styles/AddressUndeliverableDialog.module.less";

export type AddressUndeliverableDialogProps = {
  data: IVerifyAddress;
  /** Closes the picker drawer too and routes the user back to the address form. */
  onUpdate: () => void;
  /** Closes the picker drawer too and saves the user's input with override=true. */
  onProceed: () => void;
};

/**
 * Stacks on top of `NewAddressConfirmationDrawer` when Lob has flagged the
 * address as undeliverable. The user picks "Update address" (back to the
 * form, field highlighted) or "Proceed with address as is" (save with
 * `is_deliverable_user_override=True`).
 */
const AddressUndeliverableDialog = ({
  data,
  onUpdate,
  onProceed,
}: AddressUndeliverableDialogProps) => {
  const { close } = useCurrentDialog();

  const message =
    (data.reason_code && ADDRESS_REASON_CODE_MESSAGES[data.reason_code]) ||
    data.message ||
    ADDRESS_REASON_CODE_MESSAGES[AddressReasonCode.UnknownUndeliverable];

  const handleUpdate = () => {
    close();
    onUpdate();
  };

  const handleProceed = () => {
    close();
    onProceed();
  };

  return (
    <div className={styles.content}>
      <div className={styles.iconWrap}>
        <Icon icon={faExclamationCircle} />
      </div>
      <div className={styles.text}>
        <h2 className={styles.title}>Undeliverable address</h2>
        <div className={styles.description}>{message}</div>
      </div>
      <div className={styles.actions}>
        <Button variant="primary" onClick={handleUpdate}>
          Update address
        </Button>
        <Button variant="secondary" onClick={handleProceed}>
          Proceed with address as is
        </Button>
      </div>
    </div>
  );
};

export default AddressUndeliverableDialog;
